import algoliasearch from 'algoliasearch';
import { getStorefront } from "@hooks/useStorefront";

async function getSearchProducts(indexHash) {
  const storefront = getStorefront();
  try {
    const response = await fetch(`${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_API}/search/${indexHash}/${storefront}`, {
      headers: { Accept: "application/json" },
    });
    const { data } = await response.json();
    return data;
  } catch(err) { 
    return [];
  }
}


async function postReturnSearchProducts(indexHash, alogliaSearchResults) {
  const storefront = getStorefront();
  try {
    const response = await fetch(`${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_API}/search/${indexHash}/${storefront}`, {
      method: "POST",
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(alogliaSearchResults),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const { data } = await response.json();
    return data;
  } catch(err) {
    console.log('ERR',err);
    return [];
  }
}

const searchClient = algoliasearch('H2A4NDL5ID', '51cc01d8051431180e8ae392af5be7ac');

async function sha256(source) {
  const sourceBytes = new TextEncoder().encode(source);
  const digest = await crypto.subtle.digest("SHA-256", sourceBytes);
  const resultBytes = [...new Uint8Array(digest)];
  const hexHash = resultBytes.map(x => x.toString(16).padStart(2, '0')).join("");
  return hexHash.substring(0, 20);
}
const storefront = getStorefront();
const index = searchClient.initIndex(`production_${storefront}_products`);
console.log('Algolia index initiated', `production_${storefront}_products`);
index.setSettings({
  searchableAttributes: [
   'title',
   'tags',
   'type',
   'availableForSale',
   'sanity.shopifyProducts.colour.tags.value',
   'variants.selectedOptions.value'
 ],
 attributesForFaceting: [
  'title',
  'tags',
  'type',
  'availableForSale',
  'sanity.shopifyProducts.colour.tags.value',
  'variants.selectedOptions.value'
 ]
}).then((res) => {
    console.log('SETUP', res);
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=kotn.com";
}

export function getTotalProducts(searchTerm, requestOptions) {
  return new Promise((resolve, reject) => {
    index.search(searchTerm, requestOptions)
      .then(({ hits, queryID }) => {
        resolve({
          nextProducts: hits,
          count: hits.length,
          queryId: queryID
        })
      }).catch((err) => {
        reject(err);
      })
  })
}

const addSortFields = (list) => {
  const listWithSortFields = list.map((product, index) => {
    const price = getPrice(product);
    const discount = getDiscountPercent(product);

    return {
      ...product,
      sortBy: {
        price: price,
        discount: discount,
        featured: index,
      },
    };
  });

  return listWithSortFields;
};

const getPrice = (product) => {
  const { variants } = product;

  const price = variants.map((variant) => {
    const price = variant.presentmentPrices
      .filter((item) => item.price.currencyCode === "CAD")
      .map((item) => item.price.amount);

    return price[0];
  });

  return parseFloat(price[0]);
};

const getDiscountPercent = (product) => {
  const { variants } = product;

  const prices = variants.map((variant) => {
    const items = variant.presentmentPrices
      .filter((item) => item.price.currencyCode === "CAD")
      .map((item) => ({
        price: item.price.amount,
        compareAtPrice: item.compareAtPrice?.amount ? item.compareAtPrice.amount : 0,
      }));

    return items[0];
  });

  const { price, compareAtPrice } = prices[0];
  const discount = Math.floor(100 - (parseFloat(price) / parseFloat(compareAtPrice)) * 100);

  return discount > 0 ? discount : 0;
};

// We technically need all the products to know what filters to generate in the UI
// Since algolia is pretty fast and we don't have a lot of products its fast enough to
// fetch all the products at once.
export async function fetchAllProducts(searchTerm, filterString) {
  const hashedSearchIndex = await sha256(`${searchTerm}${filterString}`);

  try { 
    const _products = await getSearchProducts(hashedSearchIndex);
    console.log('SAERCH1 PRODUCTS', _products);
    if (_products && _products.length > 0) {
      console.log(`[Redis search] fetching from cache [${hashedSearchIndex}]`);
      return _products;
    }
    console.log(`[Redis search] no products found in cache ${hashedSearchIndex}`);
  } catch (err) {
    console.log(`[Redis search] GET not available [${hashedSearchIndex}]`);
  }

  console.log('[Redis search] fetching from algolia')
  let keepFetching = true;
  let page = 0;

  const products = [];
    while(keepFetching) {
      try {
        const requestOptions = {
          filters: filterString,
          page,
          hitsPerPage: 50,
          clickAnalytics: true
        }

        const { nextProducts, count, queryId } = await getTotalProducts(searchTerm, requestOptions);
        localStorage.setItem('algolia-query-id', queryId);
        setCookie('algolia-query-id', queryId, 7);
        if (nextProducts.length) {
          // alogolia stores variants not products so it wil sometimes return the same product X times
          // if more than one of its variants match a filter condition. So we need to add products
          // one at a time and ensure that its not already in the list of products
          nextProducts.forEach(product => {
            if (!products.find(_product => _product?.url?.slug === product?.url?.slug)) products.push(product);
          });
        }
        page++;
        if (count === 0) keepFetching = false;
      } catch (err) {
        throw new Error(err);
      }
    }

    try {
      postReturnSearchProducts(hashedSearchIndex, products); 
    } catch (err) {
      console.log('[Redis search] POST not available');
    }

    return addSortFields(products);
}
